document.addEventListener("DOMContentLoaded", () => {
  const menuBtn = document.querySelector("#menu-btn");
  const body = document.body;
  const nav = document.querySelector("#main-nav");

  function closeMenu() {
    body.classList.remove("menu-opened");
    menuBtn.classList.remove("open");
    nav.classList.add("opacity-0", "max-lg:pointer-events-none", "-translate-x-full");
    menuBtn.setAttribute("aria-expanded", "false");
  }

  menuBtn.addEventListener("click", () => {
    body.classList.toggle("menu-opened");
    menuBtn.classList.toggle("open");

    if (body.classList.contains("menu-opened")) {
      nav.classList.remove("opacity-0", "max-lg:pointer-events-none", "-translate-x-full");
      menuBtn.setAttribute("aria-expanded", "true");
    } else {
      nav.classList.add("opacity-0", "max-lg:pointer-events-none", "-translate-x-full");
      menuBtn.setAttribute("aria-expanded", "false");
    }
  });

  window.addEventListener("scroll", () => {
    if (body.classList.contains("menu-opened")) {
      closeMenu();
    }
  });
});